import SecureLS from 'secure-ls';
import { Userpilot } from 'userpilot';
import { getHubspotConsent } from './consent';
import { User } from 'types/User';

const ls = new SecureLS({ encodingType: 'aes' });

const getUserFromStorage = (): User | undefined => {
  try {
    return ls.get('user') as User | undefined;
  } catch {
    return undefined;
  }
};

const getToken = () => import.meta.env.VITE_USERPILOT_TOKEN;

const isInitialized = () => (window as any).__userpilotInitialized === true;
const setInitialized = (value: boolean) => {
  (window as any).__userpilotInitialized = value;
};

/**
 * Consent Hubspot + user connecté + pas impersonated
 */
export const canTrackUserpilot = (): boolean => {
  const consent = getHubspotConsent();
  if (consent?.analytics !== true) return false;

  const user = getUserFromStorage();
  if (!user) return false;
  if ((user as any).impersonated === true) return false;

  return true;
};

/**
 * Sync : consent + user state
 * - si interdit -> reset
 * - si autorisé -> initialize (si besoin) + identify
 */
export const syncUserpilotState = () => {
  const token = getToken();
  if (!token) return;

  const allowed = canTrackUserpilot();

  if (!allowed) {
    Userpilot.reset();
    setInitialized(false);
    return;
  }

  const user = getUserFromStorage();
  if (!user) return;

  if (!isInitialized()) {
    Userpilot.initialize(token);
    setInitialized(true);
  }

  Userpilot.identify(user.id.toString(), {
    name: `${user.firstname} ${user.lastname}`,
    email: user.email,
    createdAt: (user as any).createdAt,
    impersonated: (user as any).impersonated,
  });
};

/**
 * Appelé au démarrage : init si autorisé
 */
export const initUserpilotIfAllowed = () => {
  syncUserpilotState();
};

/**
 * Écoute les changements de consent Hubspot cookies
 */
export const watchUserpilotConsentChanges = () => {
  window.addEventListener('hsConsentChanged', syncUserpilotState);
};
